import { PlannedResourceRow } from 'components/IAP/hooks/assignmentListHooks';
import AssignmentCardPlannedResourceEdit from './AssignmentCardPlannedResourceEdit';
import ResourceSectionTableHeader from './ResourceSectionTableHeader';

type AssignmentCardEditResourceSectionProps = {
  plannedResources: PlannedResourceRow[];
};

const AssignmentCardResourceSectionEdit = ({
  plannedResources,
}: AssignmentCardEditResourceSectionProps) => {
  return (
    <>
      <div className="d-flex flex-row align-items-center fw-bold mb-2 gap-2">
        <span>PRATUS Resources Planned for Use:</span>
      </div>
      <div className="m-2">
        <ResourceSectionTableHeader />
        {plannedResources.map((res, idx) => (
          <AssignmentCardPlannedResourceEdit
            key={`${res}-${idx}`}
            plannedResource={res}
          />
        ))}
      </div>
    </>
  );
};

export default AssignmentCardResourceSectionEdit;
